export const sortQuestionsByAPIOrder = ({ questions, depth = 0 }) =>
	[...(questions || [])].map(({ dependency_questions = [], children = [], ...singleQuestion }, index) => ({
		...singleQuestion,
		sort_order: index + 1,
		...(dependency_questions?.length
			? {
					dependency_questions: sortQuestionsByAPIOrder({
						questions: dependency_questions || [],
						depth: depth + 1,
					}),
			  }
			: []),
		...(children?.length
			? { children: sortQuestionsByAPIOrder({ questions: children || [], depth: depth + 1 }) }
			: []),
	}));

export const prepareDependenciesQuestionsWithRepeatedOnes = ({ questions = [], depth = 0 }) => {
	let updatedQuestions = [];
	questions.forEach(
		({
			set_as_not_examined: _set_as_not_examined,
			set_as_normal: _set_as_normal,
			selected_answers: _selected_answers,
			hide_dependency: _hide_dependency,
			output_text: _output_text,
			has_abnormal_answers: _has_abnormal_answers,
			normal_text: _normal_text,
			abnormal_text: _abnormal_text,
			dependency_questions: _dependency_questions,
			repeated_dependencies_limit,
			children = [],
			note_questions = [],
			...singleQuestion
		}) => {
			const noteQuestionsLength = note_questions?.length;
			const sharableQuestionsAttributes = {
				...(singleQuestion || {}),
				note_questions,
				repeated_dependencies_limit: Math.max(+repeated_dependencies_limit - +noteQuestionsLength, 0),
			};
			updatedQuestions = [
				...(updatedQuestions || []),
				...(!noteQuestionsLength
					? [
							{
								...(sharableQuestionsAttributes || {}),
								children: [
									...(prepareDependenciesQuestionsWithRepeatedOnes({
										questions: [...(children || [])],
										depth: depth + 1,
									}) || []),
								],
							},
					  ]
					: note_questions.map((singleNoteQuestion) => ({
							...(sharableQuestionsAttributes || {}),
							...(singleNoteQuestion || {}),
							sort_order:
								sharableQuestionsAttributes.sort_order ?? singleNoteQuestion.sort_order,
							dependency_questions: [
								...(prepareDependenciesQuestionsWithRepeatedOnes({
									questions: [...(singleNoteQuestion?.dependency_questions || [])],
									depth: depth + 1,
								}) || []),
							],
							children: [
								...(prepareDependenciesQuestionsWithRepeatedOnes({
									questions: [
										...(Array.isArray(singleNoteQuestion?.children) &&
										!singleNoteQuestion?.children?.length
											? [...(children || [])]
											: [...(singleNoteQuestion?.children || [])]),
									],
									depth: depth + 1,
								}) || []),
							],
					  })) || []),
			];
		}
	);
	return updatedQuestions;
};

export const prepareBasicQuestionsForStore = (questions = []) =>
	prepareDependenciesQuestionsWithRepeatedOnes({
		questions: [...(sortQuestionsByAPIOrder({ questions: [...(questions || [])] }) || [])],
	}) || [];
